import { Avatar as AvatarImpl } from "lib-core"
export const Avatar = AvatarImpl

export default Avatar
